import React from "react";

import CircularProgress from "@mui/material/CircularProgress";

import styles from "./PageChange.module.scss";

export default function PageChange(props) {
  return (
    <div>
      <div className={styles.wrapperDiv}>
        <div className={styles.iconWrapper}>
          <CircularProgress className={styles.progress} />
        </div>
        <h4 className={styles.title}>
          Loading page contents for: {props.path}
        </h4>
      </div>
    </div>
  );
}
